var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload" },
    [
      _c(
        "div",
        { staticClass: "btn-list" },
        [
          _c(
            "el-upload",
            {
              staticClass: "excel-btn",
              attrs: {
                action: _vm.path + "/excel/importExcel",
                headers: { "x-token": _vm.token },
                "on-success": _vm.loadExcel,
                "show-file-list": false,
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-upload2",
                  },
                },
                [_vm._v("导入")]
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "excel-btn",
              attrs: {
                size: "small",
                type: "primary",
                icon: "el-icon-download",
              },
              on: {
                click: function ($event) {
                  return _vm.handleExcelExport("ExcelExport.xlsx")
                },
              },
            },
            [_vm._v("导出")]
          ),
          _c(
            "el-button",
            {
              staticClass: "excel-btn",
              attrs: {
                size: "small",
                type: "success",
                icon: "el-icon-download",
              },
              on: {
                click: function ($event) {
                  return _vm.downloadExcelTemplate()
                },
              },
            },
            [_vm._v("下载模板")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            "row-key": "ID",
            stripe: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", "min-width": "100", prop: "ID" },
          }),
          _c("el-table-column", {
            attrs: { label: "路由Name", "min-width": "160", prop: "name" },
          }),
          _c("el-table-column", {
            attrs: { label: "路由Path", "min-width": "160", prop: "path" },
          }),
          _c("el-table-column", {
            attrs: { label: "是否隐藏", "min-width": "100", prop: "hidden" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.hidden ? "隐藏" : "显示")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "父节点", "min-width": "90", prop: "parentId" },
          }),
          _c("el-table-column", {
            attrs: { label: "排序", "min-width": "70", prop: "sort" },
          }),
          _c("el-table-column", {
            attrs: { label: "文件路径", "min-width": "360", prop: "component" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }